/** @jsxImportSource @emotion/react */
import React from 'react'
import { FormControl, FormGroup } from '@mui/material'
import { cubitFormStyles } from './cubit-form-styles'
import { DatePicker } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { isValidDate } from '../../../utils/date-utils'
import { getDateFormat } from '../../../translation/translation-helper'
const CubitDatePickerAdapter: React.FC<any> = (props: any) => {
    const {
        label,
        input: { value, onChange },
    } = props

    return (
        <FormControl css={cubitFormStyles.field}>
            <FormGroup row>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        slotProps={{ textField: { variant: 'standard', margin: 'dense' } }}
                        format={getDateFormat()}
                        label={label}
                        value={isValidDate(value) ? value : null}
                        onChange={(newValue) => {
                            onChange(newValue)
                        }}
                        //renderInput={(params: any) => <TextField margin={'dense'} variant={'standard'} {...params} />}
                    />
                </LocalizationProvider>
            </FormGroup>
        </FormControl>
    )
}

export { CubitDatePickerAdapter }
